import { useEffect, useState, Fragment } from "react";
import { i18n, initializeI18n } from "../localization/i18n";
import logoImg from "../stories/assets/FooterLogo.svg";

// Footer (Figma 525:5765): dark bar — logo left; right column = row1 (policy links + socials),
// row2 (company meta line). Privacy Policy highlighted. CMS-driven labels/socials/company info.
export default function Footer({ props }) {
  const [lang, setLang] = useState("");

  useEffect(() => {
    if (!i18n.isInitialized) initializeI18n().then(() => setLang(i18n.language));
    else setLang(i18n.language);
  }, []);

  const links = [
    { label: props?.footerTitleTermsOfUse || "Terms of Service", href: `/${lang}/terms` },
    { label: props?.footerTitleRefundPolicy || "Refund Policy", href: `/${lang}/refund-policy` },
    { label: props?.footerTitleOperatingPolicy || "Operating Policy", href: `/${lang}/operating-policy` },
    { label: props?.footerTitlePrivacyPolicy || "Privacy Policy", href: `/${lang}/privacy`, highlight: true },
  ];

  const socials = props?.socialNetworkList?.filter((s) => s?.url) || [];

  // Company info comes from CMS (companyInformation) as one string with "ㅣ"/"|" separators.
  // Split it so the separators render as evenly padded vertical dividers (Figma 525:5765).
  const metaParts = (props?.companyInformation || "")
    .split(/\s*[ㅣ|｜∣]\s*/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <footer className="kd-footer">
      <div className="kd-footer__inner">
        <div className="kd-footer__brand">
          <img className="kd-footer__logo" src={props?.footerLogo || logoImg} alt="KeduAll" />
        </div>

        <div className="kd-footer__right">
          <div className="kd-footer__row1">
            <nav className="kd-footer__links">
              {links.map((l, i) => (
                <a key={i} href={l.href} className={"kd-footer__link" + (l.highlight ? " kd-footer__link--hl" : "")}>
                  {l.label}
                </a>
              ))}
            </nav>

            {socials.length > 0 && (
              <div className="kd-footer__socials">
                {socials.map((s, i) => (
                  <a key={i} className="kd-footer__social" href={s.url} target="_blank" rel="noopener noreferrer" aria-label="social link">
                    <img src={s.logo} alt="" />
                  </a>
                ))}
              </div>
            )}
          </div>

          {metaParts.length > 0 && (
            <div className="kd-footer__meta">
              {metaParts.map((p, i) => (
                <Fragment key={i}>
                  {i > 0 && <i className="kd-footer__sep" aria-hidden="true" />}
                  <span className="kd-footer__meta-item">{p}</span>
                </Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}
